export type BoolValue = {
  bool: boolean
}
export type IntValue = {
  num: number
}
export type StringValue = {
  str: string
}
export type HtmlValue = {
  html: string
}
export type FieldValue = IntValue | StringValue | BoolValue | HtmlValue

export type ContentField = {
  readonly identifier: string
  readonly uniqueId: string
  readonly value: FieldValue
  readonly type: 'boolean' | 'string' | 'html' | 'number'
}

export type GqlContent = {
  readonly fields: ContentField[]
  readonly version: number | null
}

export const tryGetStringFieldValue: (c: GqlContent, identifier: string) => string | undefined = (c, identifier) => {
  const fld = c.fields.find((f) => f.identifier === identifier)
  if (!fld) return undefined
  if (!fld.value) return undefined
  if ('str' in fld.value) return fld.value.str
  return undefined
}

export const tryGetHtmlFieldValue: (c: GqlContent, identifier: string) => string | undefined = (c, identifier) => {
  const fld = c.fields.find((f) => f.identifier === identifier)
  if (!fld) return undefined
  if (!fld.value) return undefined
  if ('str' in fld.value) return fld.value.str
  return undefined
}

export const tryGetBoolFieldValue: (c: GqlContent, identifier: string) => boolean | undefined = (c, identifier) => {
  const fld = c.fields.find((f) => f.identifier === identifier)
  if (!fld) return undefined
  if (!fld.value) return undefined
  if ('bool' in fld.value) return fld.value.bool
  return undefined
}
